import http from "@/shared/http";

class LLMConfigService {
  getFeatureCatalog() {
    return http.get("llm-config/features");
  }

  listOverrides() {
    return http.get("llm-config");
  }

  getEffectiveModels() {
    return http.get("llm-config/effective");
  }

  putOverride(feature, body) {
    return http.put(`llm-config/${encodeURIComponent(feature)}`, body);
  }

  deleteOverride(feature) {
    return http.delete(`llm-config/${encodeURIComponent(feature)}`);
  }
}

export default new LLMConfigService();
